import styles from '@hts/entities/Card/styles/InfoContent/AddMusic/MusicBlock.module.scss';
import { useAudioPlayerStore } from '@hts/shared/libs/zustand';
import { ICardAudioItemInput } from '@hts/shared/types';
import { HtsAudioPlayer, HtsCheckbox } from '@hts/shared/ui';
import { memo, useCallback, useRef } from 'react';

interface MusicBlockProps {
  item: ICardAudioItemInput;
  checkedSong: ICardAudioItemInput | null;
  alwaysCheckedOne: boolean;
  chooseSong: (song: ICardAudioItemInput | null) => void;
}

export const MusicBlock: React.FC<MusicBlockProps> = memo(
  ({ item, checkedSong, alwaysCheckedOne, chooseSong }) => {
    const itemRef = useRef(item);
    itemRef.current = item;

    const isManuallyChecked = useRef(false);

    const { setActiveSong } = useAudioPlayerStore();

    const fileName = item.name ?? item.file;
    const songUrl = item.fileUrl;

    const handlePlay = useCallback(() => {
      if (!isManuallyChecked.current) {
        chooseSong(item);
      }
    }, [item, chooseSong]);

    const onCheckboxChange = useCallback(() => {
      if (checkedSong?.id === itemRef.current.id) {
        if (!alwaysCheckedOne) {
          chooseSong(null);
          isManuallyChecked.current = false;
          setActiveSong(undefined);
        }
      } else {
        chooseSong(itemRef.current);
        isManuallyChecked.current = true;
        setActiveSong(itemRef.current.id);
      }
    }, [checkedSong, alwaysCheckedOne, chooseSong, setActiveSong]);

    return (
      <div id={`song-${item.id}`}>
        <HtsAudioPlayer
          src={songUrl}
          songId={item.id}
          showDuration={false}
          showSongTitle={true}
          songTitle={fileName}
          containerClassName={styles.container}
          playButtonClassName={styles.playButton}
          sliderContentContainerClassName={styles.sliderContentContainer}
          fullWidth
          onPlay={handlePlay}
          rightContent={
            <HtsCheckbox
              checked={checkedSong?.id === item.id}
              containerClassName={styles.checkboxContainer}
              onChecked={onCheckboxChange}
            />
          }
        />
      </div>
    );
  },
  (prev, next) => {
    return (
      prev.item.id === next.item.id &&
      prev.checkedSong?.id === next.checkedSong?.id &&
      prev.alwaysCheckedOne === next.alwaysCheckedOne &&
      prev.chooseSong === next.chooseSong
    );
  }
);
